import { TechnicianAppointmentsItem, TechnicianAppointmentsQuery } from "@myapp/contract";
import { useQuery } from "@tanstack/react-query";
import { appointmentKeys } from "../appointment.keys";
import { appointmentApi } from "../service";

export function useWorkerCalendar(
  technicianId: string | null | undefined,
  query: TechnicianAppointmentsQuery,
) {
  return useQuery({
    queryKey: appointmentKeys.worker(technicianId ?? "", query),
    queryFn: async () => {
      const { data } = await appointmentApi.getByTechnicianId(technicianId!, query);
      return data as TechnicianAppointmentsItem;
    },
    enabled: Boolean(technicianId),
    placeholderData: (prev) => prev,
    refetchInterval: 60_000,
    refetchIntervalInBackground: false,
  });
}
